<template>
  <div>
    <DashboardHeader
      heading="Account"
      paragraph="Edit the details of your account"
    >
      <div>
        <Button
          v-on:button-click="saveChanges"
          type="button"
          :class="loading || error ? 'disabled' : ''"
          :disabled="loading || error"
        >
          Save Changes
          <!-- <i class="fa fa-save ml-sm"></i> -->
        </Button>
      </div>
    </DashboardHeader>
    <template>
      <TabSelector :tabs="tabs" active="Name" />
      <transition name="route">
        <keep-alive>
          <router-view></router-view>
          <router-view name="password"></router-view>
          <router-view name="api"></router-view>
        </keep-alive>
      </transition>
    </template>
  </div>
</template>

<script>
import DashboardHeader from '@/components/Dashboard/DashboardHeader';
import TabSelector from '@/components/Dashboard/TabSelector';
import Button from '@/components/DesignSystem/Button';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    DashboardHeader,
    TabSelector,
    Button,
  },
  methods: {
    ...mapActions({
      fetchUser: 'userAccount/fetchUser',
      saveChanges: 'userAccount/saveChanges',
    }),
  },
  computed: {
    ...mapGetters({
      loading: 'userAccount/loading',
      error: 'userAccount/error',
      userInfo: 'userAccount/userInfo',
    }),
    tabs() {
      const tabsElements = [
        {
          name: 'Name',
          path: '/account/name',
        },
        {
          name: 'Password',
          path: '/account/password',
        },
      ];
      if (this.userInfo.data.isApiEnabled) {
        tabsElements.push({
          name: 'API Key',
          path: '/account/api',
        });
      }
      return tabsElements;
    },
  },
  async created() {
    await this.fetchUser();
  },
};
</script>

<style lang="scss" scoped>
.route-enter-active,
.route-leave-active {
  transition-duration: 0.3s;
  transition-property: all;
  transition-timing-function: ease;
}

.route-enter-active {
  transition-delay: 0.3s;
}

.route-enter,
.route-leave-active {
  opacity: 0;
}
</style>
